import { ChangeDetectionStrategy, Component, HostBinding, Input, ViewEncapsulation } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'celum-dialog-header',
  templateUrl: './dialog-header.html',
  styleUrls: ['./dialog-header.less'],
  encapsulation: ViewEncapsulation.None,
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DialogHeader {
  @HostBinding('class.dialog-header') public cls = true;

  @Input() public headerSubtitle: string;
  @Input() public headerSubtitleParams: { [key: string]: string };
}
